import { toast } from 'react-toastify';
import { toastResponse } from '../../helper components/Toast/Toast';

import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import lang from '../../assets/i18n/en.json';
import {
  emailValidation,
  nameValidation,
  passwordValidation
} from '../../utils/Utils';
import allImages from '../../assets/images/allImages';
// import { Modal } from 'react-bootstrap';
// import { BasicPopup } from '../../Components/Common/basicPopup/BasicPopup';
import { Checkbox } from 'primereact/checkbox';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { isLogout } from '../../Redux/authSlice';
import { ChangePassword } from '../../Components/Enterprise/EnterpriseAdmin/userManagement/ChangePassword';
import { useMutation, useQuery } from '@apollo/client';
import { setLoaderFalse, setLoaderTrue } from '../../Redux/loaderSlice';
import { GetEnterpriseUser } from '../../Queries/QueriesUpdated';
import { UpdateClientUser, UpdateEnterpriseUser } from '../../Mutations/MutationsUpdated';

export const Setting = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  const authReducer = useSelector((state) => state.authReducer);
  const [passwordToggle, setPasswordToggle] = useState(true);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const [updateUserDetails, setUpdateUserDetails] = useState({
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    emailnotification: false,
    textnotification: false,
  });
  const [errors, setError] = useState({
    email: false,
    emailError: '',
    firstName: false,
    firstNameError: '',
    lastName: false,
    lastNameError: '',
    password: false,
    passwordError: '',
    confirmPasswordError: '',
    confirmPassword: false,
  });

  //Fetch Client details
  const { data } = useQuery(GetEnterpriseUser, {});

  //Assign mutaions to variable
  const [fnUpdateUserDetails, { loading }] = useMutation(
    UpdateEnterpriseUser,
    {
      onCompleted: (data) => {
        // if (data?.resetEnterpriseClientPasswordById) {
        //     props.onEditHide();
        toast.success(
          toastResponse('success', 'User details are updated successfully...!'),
        );
        // }
      },

      onError: ({ graphQLErrors }) => {
        if (graphQLErrors) {
          if (graphQLErrors[0].extensions.response) {
            if (
              graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
            )
              // Check if any of the GraphQL errors have a 401 status code
              toast.error(
                toastResponse(
                  'error',
                  ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
                ),
              );
          } else {
            toast.error(toastResponse('error', graphQLErrors[0].message));
          }
        }
      },
    },
  );

  useEffect(() => {
    // refetch();

    //Animated Loader true
    // dispatch(setLoaderTrue());

    if (data) {
      setUpdateUserDetails({
        email: data?.getEnterpriseUser?.email,
        firstname: data?.getEnterpriseUser?.firstName,
        lastname: data?.getEnterpriseUser?.lastName,
        emailnotification: data?.getEnterpriseUser?.emailNotification
          ? true
          : false,
        textnotification: data?.getEnterpriseUser?.textNotification
          ? true
          : false,
      });

      //Animated Loader false
      dispatch(setLoaderFalse());
    }
  }, [data, dispatch]);

  const fnUpdateUserAccount = () => {
    try {
      fnUpdateUserDetails({
        variables: {
          input: {
            firstName: updateUserDetails.firstname,
            lastName: updateUserDetails.lastname,
            emailNotification: updateUserDetails.emailnotification,
            textNotification: updateUserDetails.textnotification,
          }
        },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };

  return (
    <>
      <div className="mw-550px p-4" style={{ margin: '0 auto' }}>
        <form>
          <div className="mb-6">
            <h4 className="fw-bolder text-center">Account Settings</h4>
          </div>
          <div className="mb-6">
            <Form.Label>{PAGE.AUTH.SIGNUP.EMAIL.LABEL}</Form.Label>
            <Form.Control
              type="email"
              className="form-control form-control-lg form-control-solid"
              isInvalid={errors.email}
              value={updateUserDetails.email}
              onChange={(e) => {
                emailValidation(e?.target?.value, errors, setError);
                setUpdateUserDetails((updateUserDetails) => ({
                  ...updateUserDetails,
                  email: e.target.value,
                }));
              }}
              readOnly
            />
            <Form.Control.Feedback type="invalid">
              {errors.emailError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-6">
            <Form.Label>{PAGE.AUTH.SIGNUP.FIRSTNAME.LABEL}</Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-lg form-control-solid"
              isInvalid={errors.firstName}
              value={updateUserDetails.firstname}
              onChange={(e) => {
                nameValidation('firstName', e?.target?.value, setError);
                setUpdateUserDetails((updateUserDetails) => ({
                  ...updateUserDetails,
                  firstname: e.target.value,
                }));
              }}
            />
            <Form.Control.Feedback type="invalid">
              {errors.firstNameError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-6">
            <Form.Label>{PAGE.AUTH.SIGNUP.LASTNAME.LABEL}</Form.Label>
            <Form.Control
              type="text"
              className="form-control form-control-lg form-control-solid"
              isInvalid={errors.lastName}
              value={updateUserDetails.lastname}
              onChange={(e) => {
                nameValidation('lastName', e?.target?.value, setError);
                setUpdateUserDetails((updateUserDetails) => ({
                  ...updateUserDetails,
                  lastname: e.target.value,
                }));
              }}
            />
            <Form.Control.Feedback type="invalid">
              {errors.lastNameError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-6">
            <Form.Label className="w-100">
              <span>{PAGE.AUTH.SIGNIN.PASSWORD.LABEL}</span>
              <span className="float-end">
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    setShowChangePasswordPopup(true);
                  }}
                  className="theme link float-end fw-bolder"
                >
                  {'Change Password'}
                </Link>
              </span>
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                type={passwordToggle ? 'password' : 'text'}
                className="form-control form-control-lg form-control-solid "
                autoComplete="new-password"
                isInvalid={errors.password}
                onChange={(e) => {
                  setUpdateUserDetails((updateUserDetails) => ({
                    ...updateUserDetails,
                    password: e.target.value,
                  }));
                  passwordValidation(e.target.value, errors, setError);
                }}
              />
              <div className="showPasswordBlock">
                <img
                  src={allImages.showPwd}
                  className="container-fluid"
                  style={{ display: !passwordToggle ? 'block' : 'none' }}
                  onClick={(e) => {
                    setPasswordToggle((passwordToggle) => !passwordToggle);
                  }}
                  alt="show_password_icon"
                />
                <img
                  src={allImages.hidePwd}
                  className="container-fluid"
                  style={{ display: passwordToggle ? 'block' : 'none' }}
                  onClick={(e) =>
                    setPasswordToggle((passwordToggle) => !passwordToggle)
                  }
                  alt="hide_password_icon"
                />
              </div>
            </div>
            <Form.Control.Feedback
              type="required"
              style={{
                color: 'red',
                fontSize: '0.875em',
                marginTop: '0.25rem',
              }}
            >
              {errors.passwordError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-6">
            <h4 className="fw-bolder text-center">Notifications Settings</h4>
          </div>
          <div className="mb-6">
            <div className="flex align-items-center mb-2">
              <Checkbox
                inputId="emailNotification"
                name="emailNotification"
                value="emailnotification"
                onChange={(e) => {
                  setUpdateUserDetails((updateUserDetails) => ({
                    ...updateUserDetails,
                    emailnotification: e.target.checked,
                  }));
                }}
                checked={updateUserDetails.emailnotification}
              />
              <label htmlFor="emailNotification" className="ms-2">
                Receive notifications via email.
              </label>
            </div>
            <div className="flex align-items-center">
              <Checkbox
                inputId="textNotification"
                name="textNotification"
                value="textnotification"
                onChange={(e) => {
                  setUpdateUserDetails((updateUserDetails) => ({
                    ...updateUserDetails,
                    textnotification: e.target.checked,
                  }));
                }}
                checked={updateUserDetails.textnotification}
              />
              <label htmlFor="textNotification" className="ms-2">
                Receive important alerts via text message.
              </label>
            </div>
          </div>
          <div className="mb-6 text-end">
            {/* <button type='button' className='customTable action-btn btn btn-primary me-3 btn-hover-color'
                            onClick={() => {
                                dispatch(isLogout());
                                navigate("/user/login");
                            }}
                        > Log Out</button> */}
            <button
              type="button"
              className="customTable action-btn btn btn-primary btn-hover-color"
              // disabled={!(updateUserDetails.firstname && updateUserDetails.lastname && updateUserDetails.password && updateUserDetails.email && !errors.firstname && !errors.lastname && !errors.password && !errors.email)}
              onClick={fnUpdateUserAccount}
            >
              {' '}
              Save Settings{' '}
              {loading && (
                <i
                  className="spinner-grow spinner-grow-sm ms-3"
                  role="status"
                />
              )}
            </button>
          </div>
        </form>
      </div>

      <ChangePassword
        show={showChangePasswordPopup}
        onHide={() => setShowChangePasswordPopup(false)}
        userName={''}
      />
    </>
  );
};
